import { buildProp, componentSize } from "@xplus/utils/props";

export const useSizeProp = buildProp({
  type: String,
  values: ["", ...componentSize],
  default: "",
} as const);
